import React, { useState } from "react";
import { MapPin } from "lucide-react";
import SEO from "@/components/common/SEO";
import PageHero from "@/components/common/PageHero";
import MarketMap from "@/components/common/MarketMap";
import { Reveal, Stagger, StaggerItem } from "@/components/common/Reveal";
import FinalCTA from "@/components/sections/FinalCTA";
import { markets } from "@/config/site";

export default function Markets() {
  const [active, setActive] = useState(null);
  return (
    <>
      <SEO
        title="Markets We Serve | Premier Global Sourcing"
        description="We coordinate sourcing and trade enquiries across Pakistan, China, UAE, Saudi Arabia, Iran, USA and Europe. Service areas do not necessarily represent company-owned offices."
        path="/markets"
      />
      <PageHero
        eyebrow="Markets we serve"
        title="Connected to key international trade markets"
        intro="We coordinate enquiries involving selected sourcing and commercial markets across Asia, the Middle East, North America and Europe."
        breadcrumbs={[{ label: "Markets We Serve" }]}
      />

      <section className="container-page py-20 lg:py-28" data-testid="markets-section">
        <div className="grid gap-8 lg:grid-cols-12 items-start">
          <Reveal className="lg:col-span-7">
            <MarketMap activeCode={active} onHover={setActive} />
            <p className="mt-4 text-[13px] text-muted-foreground italic">
              Service areas shown do not necessarily represent company-owned offices.
            </p>
          </Reveal>
          <div className="lg:col-span-5">
            <p className="text-[18px] leading-[29px] text-navy font-medium">
              Each market represents a region where we coordinate sourcing or commercial trade
              enquiries — connecting your requirement to suitable options.
            </p>
          </div>
        </div>

        <Stagger className="mt-14 grid gap-px bg-[#D9E0E4] sm:grid-cols-2 lg:grid-cols-3 border border-[#D9E0E4] rounded-lg overflow-hidden">
          {markets.map((m) => (
            <StaggerItem key={m.code}>
              <div
                onMouseEnter={() => setActive(m.code)}
                onMouseLeave={() => setActive(null)}
                className={`h-full bg-white p-7 transition-colors ${active === m.code ? "bg-[#EAF1F4]" : ""}`}
                data-testid={`markets-page-card-${m.code}`}
              >
                <div className="flex items-center gap-2">
                  <MapPin className="h-4 w-4 text-copper" />
                  <h3 className="font-heading font-bold text-[18px] text-navy">{m.name}</h3>
                </div>
                <p className="mt-1.5 text-[12px] font-semibold uppercase tracking-wide text-teal">{m.role}</p>
                <p className="mt-3 text-[14px] text-muted-foreground leading-relaxed">{m.note}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      <FinalCTA />
    </>
  );
}
